import { render, staticRenderFns } from "./designationDetails.vue?vue&type=template&id=218d34c0&"
import script from "./designationDetails.vue?vue&type=script&lang=js&"
export * from "./designationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports